<div #wrapper>
  @if (el.scrollLeft > 0) {
  <un-icon
    type="left-circle"
    theme="fill"
    (click)="scrollLeft()"
    (press)="scrollLeft()"
  ></un-icon>
  }
  <section #el>
    <ng-content></ng-content>
  </section>
  @if ( wrapper.scrollWidth < el.scrollWidth && el.scrollLeft < el.scrollWidth -
  wrapper.scrollWidth ) {
  <un-icon
    type="right-circle"
    theme="fill"
    (click)="scrollRight()"
    (press)="scrollRight()"
  ></un-icon>
  }
</div>
